import { Color } from '@diritto/common/style/color';
import { css } from '@emotion/react';
import { ZIndex } from 'constants/zIndex';

export const getTextLineStyle = (line = 1) => css`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: ${line};

  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${line};

  word-break: break-all;
  word-wrap: anywhere;
`;

export const getTextCharacterStyle = (character: number) => css`
  overflow: hidden;
  // 말줄임표까지 붙였을때의 길이를 허용해야 하므로 4를 추가한다.
  max-width: ${character + 4}ch;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const hideScrollbar = css`
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const getCoverImageBorder = (color?: Color | 'transparent') => css`
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  max-width: 100%;

  &::before {
    content: '';
    position: absolute;
    border-radius: 3px;
    z-index: ${ZIndex.CoverImageBorder};

    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: inset 0 0 0 1px ${color ?? 'rgba(0, 0, 0, 0.05)'};
  }
`;

export const getCoverImageStyle = () => css`
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;
